module.exports = __webpack_public_path__ + "static/media/device-middle-sidebar.d2f8f16a.png";